import React from 'react';
import { Box, BoxProps } from '@mui/material';
import { DropdownOption } from 'types/common/DropdownOption';
type Props = {
  options: DropdownOption[];
  defaultOption: string | number | undefined;
  onSelect: (option: DropdownOption) => void;
  showShortLabel?: boolean;
  containerStyles?: BoxProps['sx'];
  chipStyles?: BoxProps['sx'];
  selectionBackgroundColor?: string;
  unSelectionFontColor?: string;
};
function SparkChipSelection({
  options,
  defaultOption,
  onSelect,
  showShortLabel = false,
  containerStyles,
  chipStyles,
  selectionBackgroundColor = 'var( --color-primary)',
  unSelectionFontColor = 'initial',
}: Props) {
  const [selectedOption, setSelectedOption] = React.useState(defaultOption);

  const handleOptionClick = (option: DropdownOption) => {
    setSelectedOption(option.value);
    onSelect(option);
  };
  React.useEffect(() => {
    if (!selectedOption && defaultOption) setSelectedOption(defaultOption);
  }, [defaultOption, selectedOption]);

  return (
    <Box
      sx={{
        border: '1px solid #eee',
        borderRadius: '50px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        ...containerStyles,
      }}
    >
      {options.map((option) => (
        <Box
          key={option.value}
          sx={{
            cursor: 'pointer',
            bgcolor:
              selectedOption === option.value
                ? selectionBackgroundColor
                : 'transparent',
            color:
              selectedOption === option.value ? 'white' : unSelectionFontColor,
            borderRadius: '50px',
            height: '100%',
            padding: '8px 25px',
            ...chipStyles,
          }}
          onClick={() => handleOptionClick(option)}
        >
          {showShortLabel ? option.label.split(' ')[0] : option.label}
        </Box>
      ))}
    </Box>
  );
}

export default SparkChipSelection;
